var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"d-flex flex-grow-1"},[_c('TopBar'),_vm._v(" "),_c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('Nuxt')],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }